import React, { Component } from 'react';
import Crashes from './Crashes'
import './App.css';
import ReactResizeDetector from 'react-resize-detector';
import pym from 'pym.js'

var pymChild = new pym.Child();

class App extends Component {
  _onResize () {
    pymChild.sendHeight();
  }
  render() {
    return (
      <div className="App">
        <Crashes />
        <ReactResizeDetector handleWidth handleHeight onResize={this._onResize} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js